import { z } from 'zod';

export const CustomerFormSchema = z
  .object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string(),
    email: z.string().email('Please enter valid email'),
    address: z.object({
      placeId: z.string(),
      address: z.string(),
    }),
    fabricator: z.object({
      id: z.string(),
      name: z.string(),
    }),
    originalFmiCosts: z.number().nullable(),
    d365ReplacementCosts: z.number().nullable(),
  })
  .superRefine((data, ctx: any) => {
    if (!data.firstName || !data.firstName.trim()) {
      ctx.addIssue({
        path: ['firstName'],
        message: 'First name is required',
        code: 'custom',
      });
    }

    if (!data.lastName || !data.lastName.trim()) {
      ctx.addIssue({
        path: ['lastName'],
        message: 'Last name is required',
        code: 'custom',
      });
    }

    if (!data.phone || !data.phone.trim()) {
      ctx.addIssue({
        path: ['phone'],
        message: 'Phone number is required',
        code: 'custom',
      });
    }

    if (!data.email || !data.email.trim()) {
      ctx.addIssue({
        path: ['email'],
        message: 'Email is required',
        code: 'custom',
      });
    }

    if (!data.address.placeId) {
      ctx.addIssue({
        path: ['address'],
        message: 'Address is required',
        code: 'custom',
      });
    }

    if (!data.fabricator.id) {
      ctx.addIssue({
        path: ['fabricator'],
        message: 'Fabricator is required',
        code: 'custom',
      });
    }
  });
